const typeBenefits = [
  {
    id: "ANNUAL",
    title: "Nghỉ phép hàng năm",
  },
  {
    id: "INSURANCE",
    title: "Nghỉ hưởng chế độ BHXH",
  },
  {
    id: "UNPAID",
    title: "Nghỉ không lương",
  },
  {
    id: "SICK",
    title: "Nghỉ ốm",
  },
];

export default typeBenefits;
